import { render, staticRenderFns } from "./MobileTaskCenter.vue?vue&type=template&id=3de5e382&scoped=true"
import script from "./MobileTaskCenter.vue?vue&type=script&lang=js"
export * from "./MobileTaskCenter.vue?vue&type=script&lang=js"
import style0 from "./MobileTaskCenter.vue?vue&type=style&index=0&id=3de5e382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de5e382",
  null
  
)

export default component.exports